import type {
    Academy,
    AcademyTime,
    AcademyUser,
    Answers,
    Chat,
    City,
    CoachProfile,
    Comment,
    Follow,
    Ground,
    GroundTime,
    Gym,
    GymReserve,
    League,
    Level,
    Like,
    Match,
    Post,
    Profile,
    Result,
    Setting,
    Sport,
    SportProfile,
    Team,
    TeamUser,
    Transaction,
    User,
    UserOnChat,
    Wallet
} from "~/types/models";

export const getUser = async (id: string, params: {}) => {
    const {result} = await useGet<User>(`/User/${id}`, {params})
    return result || []
}
export const getUsers = async (params: {}) => {
    const {result} = await useGet<User>(`/User`, {params})
    return result || []
}
export const getProfile = async (params: {}) => {
    const {result} = await useGet<Profile>(`/Profile`, {params})
    return result || []
}

export const getGyms = async (params: {}) => {
    const {result} = await useGet<Gym[]>(`/Gym`, {params})
    return result || []
}
export const getGym = async (id: string, params: {}) => {
    const {result} = await useGet<Gym>(`/Gym/${id}`, {params})
    return result || []
}
export const getGymReserve = async (params: {}) => {
    const {result} = await useGet<GymReserve[]>(`/gym-reserve`, {params})
    return result || []
}
export const getGymReserveById = async (id: string, params: {}) => {
    const {result} = await useGet<GymReserve>(`/gym-reserve/${id}`, {params})
    return result || []
}
export const getCities = async (params: {}) => {
    const {result} = await useGet<City[]>(`/City`, {params})
    return result || []
}
export const getLeagueResults = async (params: {}) => {
    // const {result} = await useGet<LeagueResult[]>(`/LeagueResult`, {params})
    // return result || []
}
export const getResults = async (params: {}) => {
    const {result} = await useGet<Result[]>(`/result`, {params})
    return result || []
}
export const getUserOnChats = async (params: {}) => {
    const {result} = await useGet<Result[]>(`/UserOnChat`, {params})
    return result || []
}
export const getReacts = async (params: {}) => {
    const {result} = await useGet<Result[]>(`/React`, {params})
    return result || []
}
export const getTeams = async (params: {}) => {
    const {result} = await useGet<Team[]>(`/Team`, {params})
    return result || []
}
export const getTeamUser = async (params: {}) => {
    const {result} = await useGet<TeamUser[]>(`/TeamUser`, {params})
    return result || []
}
export const getLeagues = async (params: {}) => {
    const {result} = await useGet<League[]>(`/League`, {params})
    return result || []
}
export const getLeague = async (id: string, params: {}) => {
    const {result} = await useGet<League>(`/League/${id}`, {params})
    return result || []
}
export const getLeagueTeams = async (params: {}) => {
    // const {result} = await useGet<LeagueTeam>(`League-team`, {params})
    // return result
}

export const getComments = async (params: {}) => {
    const {result} = await useGet<Comment[]>(`/Comment`, {params})
    return result || []
}
export const getMatches = async (params: {}) => {
    const {result} = await useGet<Match[]>(`/Match`, {params})
    return result || []
}
export const getMatch = async (id: string, params: {}) => {
    const {result} = await useGet<Match>(`/Match/${id}`, {params})
    return result || []
}
export const getMatchUsers = async (params: {}) => {
    // const {result} = await useGet<MatchUsers[]>(`/matchUsers`, {params})
    // return result || []
}
export const getAcademyUsers = async (params: {}) => {
    const {result} = await useGet<AcademyUser>(`/Academy-user`, {params})
    return result || []
}
export const getAcademy = async (params: {}) => {
    const {result} = await useGet<Academy[]>(`/academy`, {params})
    return result || []
}
export const getAcademyUser = async (params: {}) => {
    const {result} = await useGet<AcademyUser>(`/AcademyUser`, {params})
    return result || []
}
export const getAcademyById = async (id: string, params: {}) => {
    const {result} = await useGet<Academy>(`/academy/${id}`, {params})
    return result || []
}
export const getWallet = async (params: {}) => {
    const {result} = await useGet<Wallet>(`/wallet`, {params})
    return result || []
}
export const getTransaction = async (id: string) => {
    const {result} = await useGet<Transaction>(`/Transaction/${id}`)
    return result || []
}
export const getGrounds = async (params: {}) => {
    const {result} = await useGet<Ground[]>(`/Ground`, {params})
    return result || []
}
export const getPosts = async (params: {}) => {
    const {result} = await useGet<Post[]>(`/Post`, {params})
    return result || []
}
export const getPost = async (id: string, params: {}) => {
    const {result} = await useGet<Post>(`/Post/${id}`, {params})
    return result || []
}
export const getNotifications = async (params: {}) => {
    const {result} = await useGet<Notification[]>(`/notification`, {params})
    return result || []
}
export const getNotification = async (id: string, params: {}) => {
    const {result} = await useGet<Notification>(`/notification/${id}`, {params})
    return result || []
}
export const getChats = async (params: {}) => {
    const {result} = await useGet<Chat[]>(`/Chat`, {
        headers: {qt: 'json'},
        params
    })
    return result || []
}
export const getChat = async (id: string, params: {}) => {
    const {result} = await useGet<Chat>(`/Chat/${id}`, {params})
    return result || []
}
export const getFollow = async (params: {}) => {
    const {result} = await useGet<Follow[]>(`/follow`, {params})
    return result || []
}
export const getLevels = async (params: {}) => {
    const {result} = await useGet<Level[]>(`/Level`, {params})
    return result || []
}
export const getGroundTimes = async (params: {}) => {
    const {result} = await useGet<GroundTime[]>(`/GroundTime`, {params})
    return result || []
}
export const getAcademyTimes = async (params: {}) => {
    const {result} = await useGet<AcademyTime[]>(`/AcademyTime`, {params})
    return result || []
}
export const getSetting = async () => {
    const {result} = await useGet<Partial<Setting>>(`/Setting`)
    return result && !Array.isArray(result) ? result : {}
}
export const getCoachProfile = async (params: {}) => {
    const {result} = await useGet<CoachProfile>(`/CoachProfile`, {params})
    return result || []
}
export const getSport = async (params: {}) => {
    const {result} = await useGet<Sport[]>(`/Sport`, {params})
    return result || []
}
export const getSportProfile = async (params: {}) => {
    const {result} = await useGet<SportProfile[]>(`/sportProfile`, {params})
    return result || []
}

export const getAnswers = async (params: {}) => {
    const {result} = await useGet<Answers[]>(`/Answers`, {params})
    return result || []
}


// posts =============================================================================================
export const postProfile = async (profile: Partial<Profile>) => {
    const {result} = await usePost(`/profile`, profile);
    return result;
}
export const postAnswers = async (Answer: Partial<Answers>) => {
    const {result} = await usePost(`/Answers`, Answer);
    return result;
}

export const postLeague = async (League: Partial<League>) => {
    const {result} = await usePost(`/League`, League);
    return result;
}
export const postComment = async (Comment: Partial<Comment>) => {
    const {result} = await usePost(`/Comment`, Comment);
    return result;
}
export const postFollow = async (Follow: Partial<Follow>) => {
    const {result} = await usePost(`/follow`, Follow);
    return result;
}
export const postAcademy = async (Academy: Partial<Academy>) => {
    const {result} = await usePost(`/Academy`, Academy);
    return result;
}
export const postCoachProfile = async (CoachProfile: Partial<CoachProfile>) => {
    const {result} = await usePost(`/coach-profile`, CoachProfile);
    return result
}
export const postLike = async (Like: Partial<Like>) => {
    const {result} = await usePost(`/like`, Like);
    return result
}
export const postChat = async (Chat: Partial<Chat>) => {
    const {result} = await usePost('/chat', Chat);
    return result
}
export const postMatch = async (Match: Partial<Match>) => {
    const {result} = await usePost('/Match', Match);
    return result
}

export const joinMatchPayment = async (matchId: string, data: { teamId?: string, requestId?: string }) => {
    return await usePost(`/match/${matchId}/join-payment`, data)
}

export const postUserOnChat = async (UserOnChat: Partial<UserOnChat>) => {
    const {result} = await usePost('/user-on-chat', UserOnChat);
    return result
}
export const postResult = async (Result: Partial<Result>) => {
    const {result} = await usePost('/Result', Result);
    return result
}


// export const postGymReserve = async (GymReserve: Partial<GymReserve>) => {
//     const {result} = await usePost('/GymReserve', GymReserve);
// }

export const postGymReserve = async (GymReserve: Partial<GymReserve>) => {
    const {result} = await usePost('/GymReserve', GymReserve);
    return result
}

export const postTransaction = async (Transaction: Partial<Transaction>) => {
    const {result} = await usePost('/Transaction', Transaction);
    return result
}
export const postTeamUser = async (TeamUser: Partial<TeamUser>) => {
    const {result} = await usePost('/TeamUser', TeamUser);
    return result
}
export const postSportProfile = async (SportProfile: Partial<SportProfile>) => {
    const {result} = await usePost('sportProfile', SportProfile)
    return result
}


/////// put
export const putUser = async (id: string, data: User) => {
    const {result} = await usePut(`/User/${id}`, data)
    return result
}

export const putSportProfile = async (id: string, data: Partial<SportProfile>) => {
    const {result} = await usePut(`/sportProfile/${id}`, data)
    return result
}

// export const putReservableTime = async (id:string, data:ReserveableTime) => {
//     const {result} = await usePut(`/ReserveableTime/${id}`, data)
//     return result
// }

// delete =========================================================================================

export const deleteLeague = async (id: string) => {
    const {result} = await useDelete(`/League/${id}`)
    return result
}
export const deleteAcademy = async (id: string) => {
    const {result} = await useDelete(`/Academy/${id}`)
    return result
}

export const deletePost = async (id: string) => {
    const {result} = await useDelete(`/Post/${id}`)
    return result
}
export const deleteFollow = async (id: string) => {
    const {result} = await useDelete(`/Follow/${id}`)
    return result
}
export const deleteLike = async (id: string) => {
    const {result} = await useDelete(`/like/${id}`)
    return result
}

export const deleteUserOnChats = async (id: string) => {
    const {result} = await useDelete(`/UserOnChat/${id}`)
    return result
}

export const deleteChat = async (id: string) => {
    const {result} = await useDelete(`/Chat/${id}`)
    return result
}
export const deleteTeam = async (id: string) => {
    const {result} = await useDelete(`/Team/${id}`)
    return result
}
export const deleteReact = async (id: string) => {
    const {result} = await useDelete(`/React/${id}`)
    return result
}

export const direction = async (from: [number, number], to: [number, number]) => {
    try {
        const url = new URL('https://api.neshan.org/v1/direction')
        url.searchParams.append('origin', `${from[1]},${from[0]}`)
        url.searchParams.append('destination', `${to[1]},${to[0]}`)

        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Api-Key': 'service.af275ce2b05243cdb1b6280115d6889f'
            }
        })
        const data = await response.json()
        return data?.routes?.[0]?.geometry || ''
    } catch (error) {
        console.error('Direction API Error:', error)
        return ''
    }
}
